module.exports = __webpack_public_path__ + "static/dafnis-standard-a8c5391100bd8fd7b66593c27f4851ad.jpg";